import {ssrSafeWindow} from '@github-ui/ssr-utils'
import {Link} from '@primer/react'
import {Dialog} from '@primer/react/experimental'
import {useEffect} from 'react'

import styles from './BranchNextStepDesktop.module.css'

export type BranchNextStepDesktopProps = {
  branch: string | null
  repository: string
  owner: string
  onClose: () => void
  returnFocusRef?: React.RefObject<HTMLElement | null>
}

export const BranchNextStepDesktop = ({
  branch,
  repository,
  owner,
  onClose,
  returnFocusRef,
}: BranchNextStepDesktopProps) => {
  const desktopUrl = `x-github-client://openRepo/${ssrSafeWindow?.origin}/${owner}/${repository}?branch=${branch}`

  useEffect(() => {
    if (ssrSafeWindow) {
      ssrSafeWindow.location.replace(desktopUrl)
    }
  }, [desktopUrl])

  return (
    <Dialog
      width="large"
      height="auto"
      title={'Opening branch in GitHub Desktop...'}
      onClose={onClose}
      returnFocusRef={returnFocusRef}
    >
      <span className={styles.desktopInstructionsText}>
        If nothing happens, make sure&nbsp;
        <Link inline target="_blank" href="https://desktop.github.com/" rel="noreferrer">
          GitHub Desktop
        </Link>
        &nbsp;is installed and set up properly, then&nbsp;
        <Link inline href={desktopUrl}>
          try again
        </Link>
        .
      </span>
    </Dialog>
  )
}
